import SectionHero from 'components/SectionHero/SectionHero';
import React from 'react';
import SectionGridFeaturePlaces from './SectionGridFeaturePlaces';
import SectionClientSay from 'components/SectionClientSay/SectionClientSay';
import SectionWhySchoon from '../PageAbout/SectionWhySchoon';
import SectionPrioritizingSustainability from '../PageAbout/SectionPrioritizingSustainability';
import { AnimateOnScroll } from 'components/AnimationOnScroll/AnimationOnScroll';
import { CallToAction } from '../../components/CallToAction/CallToAction';
import SectionWhoWeAre from '../../components/SectionWhoWeAre/SectionWhoWeAre';
import BgGlassmorphism from '../../components/BgGlassmorphism/BgGlassmorphism';

function PageHome() {
  return (
    <div className="relative overflow-hidden w-full">
      {/* GLASSMOPHIN */}
      <BgGlassmorphism/>


      <div className={'dark:bg-gradient-to-r dark:from-[#00256c] dark:to-[#591006] space-y-20'}>
        {/* SECTION HERO */}

        <SectionHero className="pt-10 lg:pt-16"/>


        <AnimateOnScroll>
          <CallToAction/>
        </AnimateOnScroll>

        {/*SECTION*/}

        <SectionGridFeaturePlaces/>

        {/* SECTION WHO WE ARE */}
        <AnimateOnScroll>
          <SectionWhoWeAre/>
        </AnimateOnScroll>

        <AnimateOnScroll>
          <SectionPrioritizingSustainability/>
        </AnimateOnScroll>

        <AnimateOnScroll delay={0.5}>
          <SectionWhySchoon/>
        </AnimateOnScroll>

        {/* SECTION */}
        <AnimateOnScroll>
          <div className="relative py-16">
            {/*<BackgroundSection/>*/}
            <SectionClientSay uniqueClassName="PageHome_"/>
          </div>
        </AnimateOnScroll>
      </div>
    </div>
  );
}

export default PageHome;
